import * as Sentry from '@sentry/vue'
// import { Integrations } from '@sentry/tracing'

export default async ({ app, router, Vue }) => {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DNS,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE,
    tracePropagationTargets: ['localhost', /^https:\/\/rebit\.dev\/api/, /^https:\/\/rebitmoney\.com\/api/],
    replaysSessionSampleRate: process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE
  })
}
